export default "__VITE_ASSET__3e8eb735__"